export const BASE_IMAGE_URL =
  'https://www.nerdwallet.com/cdn/apps/prod/front-page/images/homepage/superbowl';

export const NW_PLUS_URL =
  'https://www.nerdwallet.com/lp/nerdwallet-plus-main?trk=nwplus_rewards_campaign_module';

export const BEST_OF_AWARDS_2025_URL =
  'http://www.nerdwallet.com/awards?utmcampaign=gtm_BOA2025&utm_source=nerdwallet&utm_medium=banner';
